<template>
  <div>
    <p>{{ t('determineDewPoint') }}</p>
    <EquationBlock
      :equations="equations"
    />
    <hr />
    <div class="row">
      <div class="col-sm">
        <GenericInput
          :input-label="t('temperature')"
          v-model.number="temperature"
          :conversion-factors="ConversionFactors.temperature"
        />
        <FixedUnitInput
          :input-label="t('relativeHumidity')"
          v-model.number="relHumidity"
          :unit="t('percent')"
        />
      </div>
      <div class="col-sm">
        <GenericOutput
          :output-label="t('dewPoint')"
          :number="dewPoint"
          :conversion-factors="ConversionFactors.temperature"
          show-splitter="false"
        />
      </div>
    </div>
  </div>
</template>

  
  <script>
  import { ref, computed, reactive } from 'vue';
  import GenericInput from '../inputs/GenericInput.vue';
  import FixedUnitInput from '../inputs/FixedUnitInput.vue';
  import GenericOutput from '../inputs/GenericOutput.vue';
  import EquationBlock from '../inputs/EquationBlock.vue';
  import ConversionFactors from '../../utils/conversion_factors';
  import { defaultRound } from '../../utils/math';
  import { useI18n } from 'vue-i18n';
  
  export default {
    components: {
      GenericInput,
      FixedUnitInput,
      GenericOutput,
      EquationBlock,
    },
    setup() {
      const temperature = ref(25);
      const relHumidity = ref(65);
      const CONSTANTS = {
        A: 6.112,
        B: 17.67,
        C: 243.5,
      };

      const { t, tm } = useI18n();

      // Create a reactive object with a function
      const translations = reactive({
        t: (key) => t(key)
      })

      const equations = computed(() => {
          return tm('dewPointEquations');
      })
  
      const vapPressureHelper = (relHumidity, temp) => {
        return Math.log(relHumidity / 100) + CONSTANTS.B * temp / (CONSTANTS.C + temp);
      };
  
      const dewPoint = computed(() => {
        const vapPressure = vapPressureHelper(relHumidity.value, temperature.value);
        return defaultRound(CONSTANTS.C * vapPressure / (CONSTANTS.B - vapPressure));
      });
  
      return {
        temperature,
        relHumidity,
        dewPoint,
        ConversionFactors,
        equations,  
        t: translations.t

      };
    },
  };
  </script>
  